import { StringUtil } from '@nomidio/common';

export enum ClientType {
  OAuth2 = 'OAUTH2',
  SAML2 = 'SAML2',
}

export function ClientTypePresentation(clientType: ClientType): string {
  switch (clientType) {
    case ClientType.OAuth2:
      return 'OAuth2 (OpenID Connect)';
    case ClientType.SAML2:
      return 'SAML 2';
    default:
      console.warn(`Mapping not handled for type '${clientType}' falling back to value`);
      return StringUtil.toPresentationFormat(clientType);
  }
}
